import React from 'react'

const BankDetailSidebar = ({selectedInstFeeDetail,currency}) => {

  return (
    <>
    <div className="total_amountWrap">
                <h3>{selectedInstFeeDetail?.amount} {currency}</h3>
                <p>Amount in {currency}</p>
            </div>
            {/* <div className="banktrf_note">
                <p><b>Note:</b> Dear Parent, After successfully completing the Direct bank Transfer of the Course Fee, Please fill out the following transaction details.</p>
            </div> */}
            {/* <div className="banktrf_bankDetail">
                <h3>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-bank" viewBox="0 0 16 16">
                        <path d="m8 0 6.61 3h.89a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v7a.5.5 0 0 1 .485.38l.5 2a.498.498 0 0 1-.485.62H.5a.498.498 0 0 1-.485-.62l.5-2A.501.501 0 0 1 1 13V6H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 3h.89L8 0ZM3.777 3h8.447L8 1 3.777 3ZM2 6v7h1V6H2Zm2 0v7h2.5V6H4Zm3.5 0v7h1V6h-1Zm2 0v7H12V6H9.5ZM13 6v7h1V6h-1Zm2-1V4H1v1h14Zm-.39 9H1.39l-.25 1h13.72l-.25-1Z"/>
                </svg>
                 Our Bank Details </h3>

                 <div className="detail_colItem">
                    <p>Name</p>
                    <h4>Allen Career Institute Overseas DMCC</h4>
                 </div>

                 <div className="detail_colItem">
                    <p>Account Number</p>
                    <h4>370840000000</h4>
                 </div>

                 <div className="detail_colItem">
                    <p>IBAN</p>
                    <h4>AE510340000000000</h4>
                 </div>

                 <div className="detail_colItem">
                    <p>Swift Code</p>
                    <h4>MEBLAEAD</h4>
                 </div>

                 <div className="detail_colItem">
                    <p>Bank Name</p>
                    <h4>Emirates Islamic Bank</h4>
                 </div>

                 <div className="detail_colItem">
                    <p>Currency</p>
                    <h4>AED</h4>
                 </div>
            </div> */}
    </>
  )
}

export default BankDetailSidebar